import React, { useContext, useCallback, useState } from "react";
import {
  Flex,
  Grid,
  GridItem,
  FullWidthContainer,
} from "@domestika-dev/prudencio/dist/atoms/Layout";
import { LiveSessionContext } from "../../context/LiveSessionContext";
import { ChatContent } from "./LiveSessionChat/ChatContent";
import { HeaderContent } from "./LiveSessionHeader/HeaderContent";
import { PlayerContent } from "./LiveSessionPlayer/PlayerContent";

export const LiveSessionContent = () => {
  const { isTeacher, chatEnabled } = useContext(LiveSessionContext);
  const [headerHeight, setHeaderHeight] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);

  const headerRef = useCallback((node) => {
    if (node !== null) {
      setHeaderHeight(node.getBoundingClientRect().height);
    }
  }, []);

  const footerRef = useCallback((node) => {
    if (node !== null) {
      setFooterHeight(node.getBoundingClientRect().height);
    }
  }, []);

  return (
    <FullWidthContainer>
      <Grid>
        <GridItem gridRow={1}>
          <HeaderContent headerRef={headerRef} showLeaveButton={!isTeacher} />
        </GridItem>
        <GridItem gridRow={2}>
          <FullWidthContainer>
            <Flex>
              <PlayerContent
                footerRef={footerRef}
                headerHeight={headerHeight}
                footerHeight={footerHeight}
              />
              {chatEnabled && (
                <ChatContent headerHeight={headerHeight} footerHeight={footerHeight} />
              )}
            </Flex>
          </FullWidthContainer>
        </GridItem>
      </Grid>
    </FullWidthContainer>
  );
};

export default LiveSessionContent;
